<template>
  <v-list dense>
        <v-list-item-group>
          <v-list-item
           v-for="item in routes"
           :key="item.path"
           @click="routeTo(item.name)"
           v-if="item.hidden === true"
          >
            <v-layout wrap>
              <v-list-item-action class="justify-center">
                <img
                  width="32"
                  class="filter-green"
                  v-bind:src="item.meta.src"
                  :class="item.meta.selected ? `color: #82b1ff` : `color:white`"
                >
              </v-list-item-action>
            </v-layout>
          </v-list-item>
        </v-list-item-group>
      </v-list>
</template>
<script>
import {FilterPermissions} from '@/utils/Permissions.js'
export default {
  props: ['drawer'],
  data () {
    return {
      listView: false,
      routes: [
        {
          name: 'UserList',
          hidden: true,
          meta: {
            title: 'Users',
            src: require('@/assets/images/user-solid.svg'),
            permisionList: ['user__view_all']
          }
        },
        {
          name: 'customerList',
          hidden: true,
          meta: {
            title: 'Customers',
            src: require('@/assets/images/users-solid.svg'),
            permisionList: ['customer__view_all']
          }
        },
        {
          name: 'leadList',
          hidden: true,
          meta: {
            title: 'Leads',
            src: require('../../assets/images/comment-dollar-solid.svg'),
            permisionList: ['lead__view_all', 'lead__view_specific']
          }
        },
        {
          name: 'Salesinquiry',
          hidden: true,
          meta: {
            title: 'Sales Inquiry',
            src: require('@/assets/images/question.svg'),
            permisionList: ['sales_inquiry__view_all', 'sales_inquiry__view_specific']
          }
        },
        // {
        //   name: 'Productinquiry',
        //   hidden: true,
        //   meta: {
        //     title: 'Product Inquiry',
        //     src: require('@/assets/images/box-solid.svg'),
        //     permisionList: ['product_inquiry__view_all']
        //   }
        // },
        // {
        //   name: 'Ordertracking',
        //   hidden: true,
        //   meta: {
        //     title: 'Order Tracking',
        //     src: require('@/assets/images/truck-loading-solid.svg'),
        //     permisionList: []
        //   }
        // },
        {
          name: 'CustomerSupportTroubleshooting',
          hidden: true,
          meta: {
            title: 'Troubleshoothing',
            src: require('@/assets/images/headset-solid.svg'),
            permisionList: ['troubleshooting__view_all', 'troubleshooting__view_specific']
          }
        },
        {
          name: 'CustomerSupportTickets',
          hidden: true,
          meta: {
            title: 'Ticket',
            src: require('@/assets/images/ticket-alt-solid.svg'),
            permisionList: ['ticket__view_all', 'ticket__view_specific']
          }
        }
      ]
    }
  },
  mounted () {
    this.nevigationIconWithPermission()
  },
  methods: {
    nevigationIconWithPermission () {
      this.routes.forEach(a => {
        if (a.meta !== undefined) {
          for (let i = 0; i < a.meta.permisionList.length; i++) {
            if (FilterPermissions(a.meta.permisionList[i]) === false) {
              a.hidden = false
            }
          }
        }
      })
    },
    routeTo (path) {
      for (let index = 0; index < this.routes.length; index++) {
        if (path === this.routes[index].name) {
          this.routes[index].meta.selected = true
        } else {
          this.routes[index].meta.selected = false
        }
        this.$router.push({name: path})
      }
    }
  }
}
</script>

<style scoped>
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 0.9125rem !important;
  font-weight: 500 !important;
  line-height: 1rem;
}
.filter-green {
   filter: invert(48%) sepia(79%) saturate(906%) hue-rotate(80deg) brightness(50%) contrast(20%) grayscale(200%);
}
</style>



// WEBPACK FOOTER //
// src/View/components/leftNavigationDrawerSmall.vue